module.exports = __webpack_public_path__ + "static/img/bottom2.66564a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom2.png
// module id = pKXM
// module chunks = 24